import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./styles/NavigationBar.css";

export default function NavigationBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToTopAfterNav = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  const handleNavClick =
    (to: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
      setMenuOpen(false);
      if (location.pathname === to) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        scrollToTopAfterNav();
      }
    };

  return (
    <header className="site-header">
      <div className="nav-container">
        <div className="logo">
          <NavLink to="/" onClick={handleNavClick("/")}>
            <img
              src="/images-webp/energylogo.webp"
              alt="Your Energy Guru Logo"
              className="logo-image"
            />
          </NavLink>
        </div>

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <NavLink
            to="/"
            onClick={handleNavClick("/")}
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
          >
            Home
          </NavLink>
          <NavLink
            to="/quote"
            onClick={handleNavClick("/quote")}
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
          >
            Free Quote
          </NavLink>
          <NavLink
            to="/calculator"
            onClick={handleNavClick("/solar-calculator")}
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
          >
            Savings Calculator
          </NavLink>
          <NavLink
            to="/blog"
            onClick={handleNavClick("/blog")}
            className={({ isActive }) => (isActive ? "active-link" : undefined)}
          >
            Blog
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
